import {
  GET_SINGLE_CUSTOMERS_LIST_DATA,
  GET_SINGLE_CUSTOMERS_LIST_DATA_SUCCESS,
  GET_SINGLE_CUSTOMERS_LIST_DATA_FAIL,
  GET_SINGLE_CUSTOMERS_DATA,
  GET_SINGLE_CUSTOMERS_DATA_SUCCESS,
  GET_SINGLE_CUSTOMERS_DATA_FAIL,
  ADD_NEW_SINGLE_CUSTOMER,
  ADD_SINGLE_CUSTOMER_SUCCESS,
  ADD_SINGLE_CUSTOMER_FAIL,
  UPDATE_SINGLE_CUSTOMER,
  UPDATE_SINGLE_CUSTOMER_SUCCESS,
  UPDATE_SINGLE_CUSTOMER_FAIL,
  DELETE_SINGLE_CUSTOMER,
  DELETE_SINGLE_CUSTOMER_SUCCESS,
  DELETE_SINGLE_CUSTOMER_FAIL,
  GET_CUSTOMER_BALANCE_LIST_DATA,
  CREATE_NEW_SINGLE_CUSTOMER,
  CREATE_SINGLE_CUSTOMER_SUCCESS,
  CREATE_SINGLE_CUSTOMER_FAIL,
  GET_SINGLE_CUSTOMER_ACTIVITIES_LIST_DATA,
  GET_SINGLE_CUSTOMER_ACTIVITIES_LIST_DATA_SUCCESS,
  GET_SINGLE_CUSTOMER_ACTIVITIES_LIST_DATA_FAIL,
  SEARCH_SINGLE_CUSTOMER_URL_LINK_LIST_DATA,
  SEARCH_SINGLE_CUSTOMER_URL_LINK_LIST_DATA_SUCCESS,
  SEARCH_SINGLE_CUSTOMER_URL_LINK_LIST_DATA_FAIL,
  SEARCH_SINGLE_CUSTOMER_EXTERNAL_IDS_LIST_DATA,
  SEARCH_SINGLE_CUSTOMER_EXTERNAL_IDS_LIST_DATA_SUCCESS,
  SEARCH_SINGLE_CUSTOMER_EXTERNAL_IDS_LIST_DATA_FAIL,
  GET_SINGLE_CUSTOMER_SITE_LOCATION_LIST_DATA,
  GET_SINGLE_CUSTOMER_SITE_LOCATION_LIST_DATA_SUCCESS,
  GET_SINGLE_CUSTOMER_SITE_LOCATION_LIST_DATA_FAIL,
  GET_SINGLE_CUSTOMER_SITE_LOCATION_DATA,
  GET_SINGLE_CUSTOMER_SITE_LOCATION_DATA_SUCCESS,
  GET_SINGLE_CUSTOMER_SITE_LOCATION_DATA_FAIL,
  ADD_NEW_SINGLE_CUSTOMER_SITE_LOCATION,
  ADD_SINGLE_CUSTOMER_SITE_LOCATION_SUCCESS,
  ADD_SINGLE_CUSTOMER_SITE_LOCATION_FAIL,
  UPDATE_SINGLE_CUSTOMER_SITE_LOCATION,
  UPDATE_SINGLE_CUSTOMER_SITE_LOCATION_SUCCESS,
  UPDATE_SINGLE_CUSTOMER_SITE_LOCATION_FAIL,
  DELETE_SINGLE_CUSTOMER_SITE_LOCATION,
  DELETE_SINGLE_CUSTOMER_SITE_LOCATION_SUCCESS,
  DELETE_SINGLE_CUSTOMER_SITE_LOCATION_FAIL,
  GET_SINGLE_CUSTOMER_URL_LINK_DETAILS,
  GET_SINGLE_CUSTOMER_URL_LINK_DETAILS_SUCCESS,
  GET_SINGLE_CUSTOMER_URL_LINK_DETAILS_FAIL,
  CREATE_SINGLE_CUSTOMER_URL_LINK,
  CREATE_SINGLE_CUSTOMER_URL_LINK_SUCCESS,
  CREATE_SINGLE_CUSTOMER_URL_LINK_FAIL,
  UPDATE_SINGLE_CUSTOMER_URL_LINK,
  UPDATE_SINGLE_CUSTOMER_URL_LINK_SUCCESS,
  UPDATE_SINGLE_CUSTOMER_URL_LINK_FAIL,
  DELETE_SINGLE_CUSTOMER_URL_LINK,
  DELETE_SINGLE_CUSTOMER_URL_LINK_SUCCESS,
  DELETE_SINGLE_CUSTOMER_URL_LINK_FAIL,
  GET_CUSTOMER_URL_LINK_STATUS_LIST_DATA,
  GET_CUSTOMER_URL_LINK_STATUS_LIST_DATA_SUCCESS,
  GET_CUSTOMER_URL_LINK_STATUS_LIST_DATA_FAIL,
  GET_CUSTOMER_URL_LINK_STATUS_DETAILS,
  GET_CUSTOMER_URL_LINK_STATUS_DETAILS_SUCCESS,
  GET_CUSTOMER_URL_LINK_STATUS_DETAILS_FAIL,
  CREATE_CUSTOMER_URL_LINK_STATUS,
  CREATE_CUSTOMER_URL_LINK_STATUS_SUCCESS,
  CREATE_CUSTOMER_URL_LINK_STATUS_FAIL,
  UPDATE_CUSTOMER_URL_LINK_STATUS,
  UPDATE_CUSTOMER_URL_LINK_STATUS_SUCCESS,
  UPDATE_CUSTOMER_URL_LINK_STATUS_FAIL,
  DELETE_CUSTOMER_URL_LINK_STATUS,
  DELETE_CUSTOMER_URL_LINK_STATUS_SUCCESS,
  DELETE_CUSTOMER_URL_LINK_STATUS_FAIL,
  GET_CUSTOMER_URL_LINK_TYPE_LIST_DATA,
  GET_CUSTOMER_URL_LINK_TYPE_LIST_DATA_SUCCESS,
  GET_CUSTOMER_URL_LINK_TYPE_LIST_DATA_FAIL,
  GET_CUSTOMER_URL_LINK_TYPE_DETAILS,
  GET_CUSTOMER_URL_LINK_TYPE_DETAILS_SUCCESS,
  GET_CUSTOMER_URL_LINK_TYPE_DETAILS_FAIL,
  CREATE_CUSTOMER_URL_LINK_TYPE,
  CREATE_CUSTOMER_URL_LINK_TYPE_SUCCESS,
  CREATE_CUSTOMER_URL_LINK_TYPE_FAIL,
  UPDATE_CUSTOMER_URL_LINK_TYPE,
  UPDATE_CUSTOMER_URL_LINK_TYPE_SUCCESS,
  UPDATE_CUSTOMER_URL_LINK_TYPE_FAIL,
  DELETE_CUSTOMER_URL_LINK_TYPE,
  DELETE_CUSTOMER_URL_LINK_TYPE_SUCCESS,
  DELETE_CUSTOMER_URL_LINK_TYPE_FAIL,
  GET_CUSTOMERS_DEBIT_BALANCE_LIST_DATA,
  GET_CUSTOMERS_DEBIT_BALANCE_LIST_DATA_SUCCESS,
  GET_CUSTOMERS_DEBIT_BALANCE_LIST_DATA_FAIL,
  GET_CUSTOMERS_OVERDUE_BALANCE_LIST_DATA,
  GET_CUSTOMERS_OVERDUE_BALANCE_LIST_DATA_SUCCESS,
  GET_CUSTOMERS_OVERDUE_BALANCE_LIST_DATA_FAIL,
  GET_CUSTOMERS_BALANCE_LIST_ALL_DATA,
  GET_CUSTOMERS_BALANCE_LIST_ALL_DATA_SUCCESS,
  GET_CUSTOMERS_BALANCE_LIST_ALL_DATA_FAIL,
  CLEAR_CUSTOMER_TRANSACTIONS_LIST,
  CLEAR_CUSTOMER_TRANSACTIONS_LIST_FAIL,
  CLEAR_CUSTOMER_TRANSACTIONS_LIST_SUCCESS,
  GET_SINGLE_CUSTOMER_EXTERNAL_IDS_DETAILS,
  GET_SINGLE_CUSTOMER_EXTERNAL_IDS_DETAILS_SUCCESS,
  GET_SINGLE_CUSTOMER_EXTERNAL_IDS_DETAILS_FAIL,
  CREATE_SINGLE_CUSTOMER_EXTERNAL_IDS,
  CREATE_SINGLE_CUSTOMER_EXTERNAL_IDS_SUCCESS,
  CREATE_SINGLE_CUSTOMER_EXTERNAL_IDS_FAIL,
  UPDATE_SINGLE_CUSTOMER_EXTERNAL_IDS,
  UPDATE_SINGLE_CUSTOMER_EXTERNAL_IDS_SUCCESS,
  UPDATE_SINGLE_CUSTOMER_EXTERNAL_IDS_FAIL,
  DELETE_SINGLE_CUSTOMER_EXTERNAL_IDS,
  DELETE_SINGLE_CUSTOMER_EXTERNAL_IDS_SUCCESS,
  DELETE_SINGLE_CUSTOMER_EXTERNAL_IDS_FAIL,
  GET_SINGLE_CUSTOMER_EXTERNAL_IDS_EXTERNAL_IDENTIFICATION_PROVIDER_LIST_DATA,
  GET_SINGLE_CUSTOMER_EXTERNAL_IDS_EXTERNAL_IDENTIFICATION_PROVIDER_LIST_DATA_SUCCESS,
  GET_SINGLE_CUSTOMER_EXTERNAL_IDS_EXTERNAL_IDENTIFICATION_PROVIDER_LIST_DATA_FAIL,
  GET_SINGLE_CUSTOMER_EXTERNAL_IDS_EXTERNAL_IDENTIFICATION_PROVIDER_DETAILS,
  GET_SINGLE_CUSTOMER_EXTERNAL_IDS_EXTERNAL_IDENTIFICATION_PROVIDER_DETAILS_SUCCESS,
  GET_SINGLE_CUSTOMER_EXTERNAL_IDS_EXTERNAL_IDENTIFICATION_PROVIDER_DETAILS_FAIL,
  CREATE_SINGLE_CUSTOMER_EXTERNAL_IDS_EXTERNAL_IDENTIFICATION_PROVIDER,
  CREATE_SINGLE_CUSTOMER_EXTERNAL_IDS_EXTERNAL_IDENTIFICATION_PROVIDER_SUCCESS,
  CREATE_SINGLE_CUSTOMER_EXTERNAL_IDS_EXTERNAL_IDENTIFICATION_PROVIDER_FAIL,
  UPDATE_SINGLE_CUSTOMER_EXTERNAL_IDS_EXTERNAL_IDENTIFICATION_PROVIDER,
  UPDATE_SINGLE_CUSTOMER_EXTERNAL_IDS_EXTERNAL_IDENTIFICATION_PROVIDER_SUCCESS,
  UPDATE_SINGLE_CUSTOMER_EXTERNAL_IDS_EXTERNAL_IDENTIFICATION_PROVIDER_FAIL,
  DELETE_SINGLE_CUSTOMER_EXTERNAL_IDS_EXTERNAL_IDENTIFICATION_PROVIDER,
  DELETE_SINGLE_CUSTOMER_EXTERNAL_IDS_EXTERNAL_IDENTIFICATION_PROVIDER_SUCCESS,
  DELETE_SINGLE_CUSTOMER_EXTERNAL_IDS_EXTERNAL_IDENTIFICATION_PROVIDER_FAIL,
  GET_CUSTOMER_STATUS_LIST_DATA,
  GET_CUSTOMER_STATUS_LIST_DATA_SUCCESS,
  GET_CUSTOMER_STATUS_LIST_DATA_FAIL,
  GET_CUSTOMER_STATUS_DETAILS,
  GET_CUSTOMER_STATUS_DETAILS_SUCCESS,
  GET_CUSTOMER_STATUS_DETAILS_FAIL,
  CREATE_CUSTOMER_STATUS,
  CREATE_CUSTOMER_STATUS_SUCCESS,
  CREATE_CUSTOMER_STATUS_FAIL,
  UPDATE_CUSTOMER_STATUS,
  UPDATE_CUSTOMER_STATUS_SUCCESS,
  UPDATE_CUSTOMER_STATUS_FAIL,
  DELETE_CUSTOMER_STATUS,
  DELETE_CUSTOMER_STATUS_SUCCESS,
  DELETE_CUSTOMER_STATUS_FAIL,
  GET_CUSTOMER_TYPE_LIST_DATA,
  GET_CUSTOMER_TYPE_LIST_DATA_SUCCESS,
  GET_CUSTOMER_TYPE_LIST_DATA_FAIL,
  GET_CUSTOMER_TYPE_DETAILS,
  GET_CUSTOMER_TYPE_DETAILS_SUCCESS,
  GET_CUSTOMER_TYPE_DETAILS_FAIL,
  CREATE_CUSTOMER_TYPE,
  CREATE_CUSTOMER_TYPE_SUCCESS,
  CREATE_CUSTOMER_TYPE_FAIL,
  UPDATE_CUSTOMER_TYPE,
  UPDATE_CUSTOMER_TYPE_SUCCESS,
  UPDATE_CUSTOMER_TYPE_FAIL,
  DELETE_CUSTOMER_TYPE,
  DELETE_CUSTOMER_TYPE_SUCCESS,
  DELETE_CUSTOMER_TYPE_FAIL,
  EXPORT_CONTACTS,
  EXPORT_CONTACTS_SUCCESS,
  EXPORT_CONTACTS_FAIL,
  SEARCH_CUSTOMER,
  SEARCH_CUSTOMER_SUCCESS,
  SEARCH_CUSTOMER_FAIL,
  GET_CUSTOMER_BALANCE_HISTORICAL_AVAILABLE_DATES,
  GET_CUSTOMER_BALANCE_HISTORICAL_AVAILABLE_DATES_SUCCESS,
  GET_CUSTOMER_BALANCE_HISTORICAL_AVAILABLE_DATES_FAIL,
  GET_CUSTOMER_BALANCE_HISTORICAL_SPECIFIC_DATE,
  GET_CUSTOMER_BALANCE_HISTORICAL_SPECIFIC_DATE_SUCCESS,
  GET_CUSTOMER_BALANCE_HISTORICAL_SPECIFIC_DATE_FAIL,
  GET_CUSTOMER_BALANCE_HISTORICAL_BY_CUSTOMER,
  GET_CUSTOMER_BALANCE_HISTORICAL_BY_CUSTOMER_SUCCESS,
  GET_CUSTOMER_BALANCE_HISTORICAL_BY_CUSTOMER_FAIL,
  SEARCH_CUSTOMER_NOTE,
  SEARCH_CUSTOMER_NOTE_SUCCESS,
  SEARCH_CUSTOMER_NOTE_FAIL,
  CREATE_CUSTOMER_NOTE,
  CREATE_CUSTOMER_NOTE_SUCCESS,
  CREATE_CUSTOMER_NOTE_FAIL,
} from "./actionType";

// ****** Customer List Action Creator ******

// GET Customer List data "Read"
export const getCustomersListData = () => {
  return {
    type: GET_SINGLE_CUSTOMERS_LIST_DATA,
  };
};

export const getCustomersListDataSuccess = (customersList) => {
  return {
    type: GET_SINGLE_CUSTOMERS_LIST_DATA_SUCCESS,
    payload: customersList,
  };
};

export const getCustomersListDataFail = (error) => {
  return {
    type: GET_SINGLE_CUSTOMERS_LIST_DATA_FAIL,
    payload: error,
  };
};

// Search Customer Note
export const searchCustomerNote = (data) => {
  return {
    type: SEARCH_CUSTOMER_NOTE,
    payload: data,
  };
};
export const searchCustomerNoteSuccess = (data) => {
  return {
    type: SEARCH_CUSTOMER_NOTE_SUCCESS,
    payload: data,
  };
};
export const searchCustomerNoteFail = (error) => {
  return {
    type: SEARCH_CUSTOMER_NOTE_FAIL,
    payload: error,
  };
};

// Create Customer Note
export const createCustomerNote = (data) => {
  return {
    type: CREATE_CUSTOMER_NOTE,
    payload: data,
  };
};
export const createCustomerNoteSuccess = (data) => {
  return {
    type: CREATE_CUSTOMER_NOTE_SUCCESS,
    payload: data,
  };
};
export const createCustomerNoteFail = (error) => {
  return {
    type: CREATE_CUSTOMER_NOTE_FAIL,
    payload: error,
  };
};

// ****** Customer Action Creator ******

// GET Customer data "Read"
export const getSingleCustomersData = (id) => {
  return {
    type: GET_SINGLE_CUSTOMERS_DATA,
    payload: id,
  };
};

export const getSingleCustomersDataSuccess = (customer) => {
  return {
    type: GET_SINGLE_CUSTOMERS_DATA_SUCCESS,
    payload: customer,
  };
};

export const getSingleCustomersDataFail = (error) => {
  return {
    type: GET_SINGLE_CUSTOMERS_DATA_FAIL,
    payload: error,
  };
};

// Create New Customer "Create"
export const addSingleNewCustomer = (customer) => {
  return {
    type: ADD_NEW_SINGLE_CUSTOMER,
    payload: customer,
  };
};

export const addSingleCustomerSuccess = (customer) => {
  return {
    type: ADD_SINGLE_CUSTOMER_SUCCESS,
    payload: customer,
  };
};

export const addSingleCustomerFail = (error) => {
  return {
    type: ADD_SINGLE_CUSTOMER_FAIL,
    payload: error,
  };
};

// Update Customer "Update"
export const updateSingleCustomer = (customer) => {
  return {
    type: UPDATE_SINGLE_CUSTOMER,
    payload: customer,
  };
};

export const updateSingleCustomerSuccess = (customer) => {
  return {
    type: UPDATE_SINGLE_CUSTOMER_SUCCESS,
    payload: customer,
  };
};

export const updateSingleCustomerFail = (error) => {
  return {
    type: UPDATE_SINGLE_CUSTOMER_FAIL,
    payload: error,
  };
};

// Delete Customer "Delete"
export const deleteSingleCustomer = (id) => {
  return {
    type: DELETE_SINGLE_CUSTOMER,
    payload: id,
  };
};

export const deleteSingleCustomerSuccess = (id) => {
  return {
    type: DELETE_SINGLE_CUSTOMER_SUCCESS,
    payload: id,
  };
};

export const deleteSingleCustomerFail = (error) => {
  return {
    type: DELETE_SINGLE_CUSTOMER_FAIL,
    payload: error,
  };
};

// ****** Customer Balance Action Creator ******
// GET Customer Balance data "Read"
export const getCustomerBalanceListData = () => {
  return {
    type: GET_CUSTOMER_BALANCE_LIST_DATA,
  };
};

// Crate New Single Customer
export const createNewSingleCustomer = (customer) => {
  return {
    type: CREATE_NEW_SINGLE_CUSTOMER,
    payload: customer,
  };
};

export const createSingleCustomerSuccess = (customer) => {
  return {
    type: CREATE_SINGLE_CUSTOMER_SUCCESS,
    payload: customer,
  };
};

export const createSingleCustomerFail = (error) => {
  return {
    type: CREATE_SINGLE_CUSTOMER_FAIL,
    payload: error,
  };
};

// Get Single Customer Activities List Data
export const getSingleCustomerActivitiesListData = (id) => {
  return {
    type: GET_SINGLE_CUSTOMER_ACTIVITIES_LIST_DATA,
    payload: id,
  };
};

export const getSingleCustomerActivitiesListDataSuccess = (activities) => {
  return {
    type: GET_SINGLE_CUSTOMER_ACTIVITIES_LIST_DATA_SUCCESS,
    payload: activities,
  };
};

export const getSingleCustomerActivitiesListDataFail = (error) => {
  return {
    type: GET_SINGLE_CUSTOMER_ACTIVITIES_LIST_DATA_FAIL,
    payload: error,
  };
};

// Search Single Customer URL Link List Data
export const searchSingleCustomerURLLinkListData = (data) => {
  return {
    type: SEARCH_SINGLE_CUSTOMER_URL_LINK_LIST_DATA,
    payload: data,
  };
};

export const searchSingleCustomerURLLinkListDataSuccess = (data) => {
  return {
    type: SEARCH_SINGLE_CUSTOMER_URL_LINK_LIST_DATA_SUCCESS,
    payload: data,
  };
};

export const searchSingleCustomerURLLinkListDataFail = (error) => {
  return {
    type: SEARCH_SINGLE_CUSTOMER_URL_LINK_LIST_DATA_FAIL,
    payload: error,
  };
};

// Search Single Customer External IDs List Data
export const searchSingleCustomerExternalIDsListData = (data) => {
  return {
    type: SEARCH_SINGLE_CUSTOMER_EXTERNAL_IDS_LIST_DATA,
    payload: data,
  };
};

export const searchSingleCustomerExternalIDsListDataSuccess = (data) => {
  return {
    type: SEARCH_SINGLE_CUSTOMER_EXTERNAL_IDS_LIST_DATA_SUCCESS,
    payload: data,
  };
};

export const searchSingleCustomerExternalIDsListDataFail = (error) => {
  return {
    type: SEARCH_SINGLE_CUSTOMER_EXTERNAL_IDS_LIST_DATA_FAIL,
    payload: error,
  };
};

// Single Customer Site Location List
export const getSingleCustomerSiteLocationListData = (id) => {
  return {
    type: GET_SINGLE_CUSTOMER_SITE_LOCATION_LIST_DATA,
    payload: id,
  };
};

export const getSingleCustomerSiteLocationListDataSuccess = (data) => {
  return {
    type: GET_SINGLE_CUSTOMER_SITE_LOCATION_LIST_DATA_SUCCESS,
    payload: data,
  };
};

export const getSingleCustomerSiteLocationListDataFail = (error) => {
  return {
    type: GET_SINGLE_CUSTOMER_SITE_LOCATION_LIST_DATA_FAIL,
    payload: error,
  };
};

// Single Customer Site Location Data
export const getSingleCustomerSiteLocationData = (id) => {
  return {
    type: GET_SINGLE_CUSTOMER_SITE_LOCATION_DATA,
    payload: id,
  };
};

export const getSingleCustomerSiteLocationDataSuccess = (data) => {
  return {
    type: GET_SINGLE_CUSTOMER_SITE_LOCATION_DATA_SUCCESS,
    payload: data,
  };
};

export const getSingleCustomerSiteLocationDataFail = (error) => {
  return {
    type: GET_SINGLE_CUSTOMER_SITE_LOCATION_DATA_FAIL,
    payload: error,
  };
};

// Add Single Customer Site Location
export const addSingleCustomerSiteLocation = (data) => {
  return {
    type: ADD_NEW_SINGLE_CUSTOMER_SITE_LOCATION,
    payload: data,
  };
};

export const addSingleCustomerSiteLocationSuccess = (data) => {
  return {
    type: ADD_SINGLE_CUSTOMER_SITE_LOCATION_SUCCESS,
    payload: data,
  };
};

export const addSingleCustomerSiteLocationFail = (error) => {
  return {
    type: ADD_SINGLE_CUSTOMER_SITE_LOCATION_FAIL,
    payload: error,
  };
};

// Update Single Customer Site Location
export const updateSingleCustomerSiteLocation = (data) => {
  return {
    type: UPDATE_SINGLE_CUSTOMER_SITE_LOCATION,
    payload: data,
  };
};

export const updateSingleCustomerSiteLocationSuccess = (data) => {
  return {
    type: UPDATE_SINGLE_CUSTOMER_SITE_LOCATION_SUCCESS,
    payload: data,
  };
};

export const updateSingleCustomerSiteLocationFail = (error) => {
  return {
    type: UPDATE_SINGLE_CUSTOMER_SITE_LOCATION_FAIL,
    payload: error,
  };
};

// Delete Single Customer Site Location
export const deleteSingleCustomerSiteLocation = (id) => {
  return {
    type: DELETE_SINGLE_CUSTOMER_SITE_LOCATION,
    payload: id,
  };
};

export const deleteSingleCustomerSiteLocationSuccess = (id) => {
  return {
    type: DELETE_SINGLE_CUSTOMER_SITE_LOCATION_SUCCESS,
    payload: id,
  };
};

export const deleteSingleCustomerSiteLocationFail = (error) => {
  return {
    type: DELETE_SINGLE_CUSTOMER_SITE_LOCATION_FAIL,
    payload: error,
  };
};

// Single Customer UrlLink Details
export const getSingleCustomerURLLinkDetails = (id) => {
  return {
    type: GET_SINGLE_CUSTOMER_URL_LINK_DETAILS,
    payload: id,
  };
};

export const getSingleCustomerURLLinkDetailsSuccess = (data) => {
  return {
    type: GET_SINGLE_CUSTOMER_URL_LINK_DETAILS_SUCCESS,
    payload: data,
  };
};

export const getSingleCustomerURLLinkDetailsFail = (error) => {
  return {
    type: GET_SINGLE_CUSTOMER_URL_LINK_DETAILS_FAIL,
    payload: error,
  };
};

// Single Customer UrlLink Create
export const createSingleCustomerURLLink = (data) => {
  return {
    type: CREATE_SINGLE_CUSTOMER_URL_LINK,
    payload: data,
  };
};

export const createSingleCustomerURLLinkSuccess = (data) => {
  return {
    type: CREATE_SINGLE_CUSTOMER_URL_LINK_SUCCESS,
    payload: data,
  };
};

export const createSingleCustomerURLLinkFail = (error) => {
  return {
    type: CREATE_SINGLE_CUSTOMER_URL_LINK_FAIL,
    payload: error,
  };
};

// Single Customer UrlLink Update
export const updateSingleCustomerURLLink = (data) => {
  return {
    type: UPDATE_SINGLE_CUSTOMER_URL_LINK,
    payload: data,
  };
};

export const updateSingleCustomerURLLinkSuccess = (data) => {
  return {
    type: UPDATE_SINGLE_CUSTOMER_URL_LINK_SUCCESS,
    payload: data,
  };
};

export const updateSingleCustomerURLLinkFail = (error) => {
  return {
    type: UPDATE_SINGLE_CUSTOMER_URL_LINK_FAIL,
    payload: error,
  };
};

// Single Customer UrlLink Delete
export const deleteSingleCustomerURLLink = (id) => {
  return {
    type: DELETE_SINGLE_CUSTOMER_URL_LINK,
    payload: id,
  };
};

export const deleteSingleCustomerURLLinkSuccess = (id) => {
  return {
    type: DELETE_SINGLE_CUSTOMER_URL_LINK_SUCCESS,
    payload: id,
  };
};

export const deleteSingleCustomerURLLinkFail = (error) => {
  return {
    type: DELETE_SINGLE_CUSTOMER_URL_LINK_FAIL,
    payload: error,
  };
};

// Customer Url Link Status List
export const getCustomerURLLinkStatusListData = () => {
  return {
    type: GET_CUSTOMER_URL_LINK_STATUS_LIST_DATA,
  };
};

export const getCustomerURLLinkStatusListDataSuccess = (data) => {
  return {
    type: GET_CUSTOMER_URL_LINK_STATUS_LIST_DATA_SUCCESS,
    payload: data,
  };
};

export const getCustomerURLLinkStatusListDataFail = (error) => {
  return {
    type: GET_CUSTOMER_URL_LINK_STATUS_LIST_DATA_FAIL,
    payload: error,
  };
};

// Customer Url Link Status Details
export const getCustomerURLLinkStatusDetails = (id) => {
  return {
    type: GET_CUSTOMER_URL_LINK_STATUS_DETAILS,
    payload: id,
  };
};

export const getCustomerURLLinkStatusDetailsSuccess = (data) => {
  return {
    type: GET_CUSTOMER_URL_LINK_STATUS_DETAILS_SUCCESS,
    payload: data,
  };
};

export const getCustomerURLLinkStatusDetailsFail = (error) => {
  return {
    type: GET_CUSTOMER_URL_LINK_STATUS_DETAILS_FAIL,
    payload: error,
  };
};

// Customer Url Link Status Create
export const createCustomerURLLinkStatus = (data) => {
  return {
    type: CREATE_CUSTOMER_URL_LINK_STATUS,
    payload: data,
  };
};

export const createCustomerURLLinkStatusSuccess = (data) => {
  return {
    type: CREATE_CUSTOMER_URL_LINK_STATUS_SUCCESS,
    payload: data,
  };
};

export const createCustomerURLLinkStatusFail = (error) => {
  return {
    type: CREATE_CUSTOMER_URL_LINK_STATUS_FAIL,
    payload: error,
  };
};

// Customer Url Link Status Update
export const updateCustomerURLLinkStatus = (data) => {
  return {
    type: UPDATE_CUSTOMER_URL_LINK_STATUS,
    payload: data,
  };
};

export const updateCustomerURLLinkStatusSuccess = (data) => {
  return {
    type: UPDATE_CUSTOMER_URL_LINK_STATUS_SUCCESS,
    payload: data,
  };
};

export const updateCustomerURLLinkStatusFail = (error) => {
  return {
    type: UPDATE_CUSTOMER_URL_LINK_STATUS_FAIL,
    payload: error,
  };
};

// Customer Url Link Status Delete
export const deleteCustomerURLLinkStatus = (id) => {
  return {
    type: DELETE_CUSTOMER_URL_LINK_STATUS,
    payload: id,
  };
};

export const deleteCustomerURLLinkStatusSuccess = (id) => {
  return {
    type: DELETE_CUSTOMER_URL_LINK_STATUS_SUCCESS,
    payload: id,
  };
};

export const deleteCustomerURLLinkStatusFail = (error) => {
  return {
    type: DELETE_CUSTOMER_URL_LINK_STATUS_FAIL,
    payload: error,
  };
};

// Customer Url Link Type List
export const getCustomerURLLinkTypeListData = () => {
  return {
    type: GET_CUSTOMER_URL_LINK_TYPE_LIST_DATA,
  };
};

export const getCustomerURLLinkTypeListDataSuccess = (data) => {
  return {
    type: GET_CUSTOMER_URL_LINK_TYPE_LIST_DATA_SUCCESS,
    payload: data,
  };
};

export const getCustomerURLLinkTypeListDataFail = (error) => {
  return {
    type: GET_CUSTOMER_URL_LINK_TYPE_LIST_DATA_FAIL,
    payload: error,
  };
};

// Customer Url Link Type Details
export const getCustomerURLLinkTypeDetails = (id) => {
  return {
    type: GET_CUSTOMER_URL_LINK_TYPE_DETAILS,
    payload: id,
  };
};

export const getCustomerURLLinkTypeDetailsSuccess = (data) => {
  return {
    type: GET_CUSTOMER_URL_LINK_TYPE_DETAILS_SUCCESS,
    payload: data,
  };
};

export const getCustomerURLLinkTypeDetailsFail = (error) => {
  return {
    type: GET_CUSTOMER_URL_LINK_TYPE_DETAILS_FAIL,
    payload: error,
  };
};

// Customer Url Link Type Create
export const createCustomerURLLinkType = (data) => {
  return {
    type: CREATE_CUSTOMER_URL_LINK_TYPE,
    payload: data,
  };
};

export const createCustomerURLLinkTypeSuccess = (data) => {
  return {
    type: CREATE_CUSTOMER_URL_LINK_TYPE_SUCCESS,
    payload: data,
  };
};

export const createCustomerURLLinkTypeFail = (error) => {
  return {
    type: CREATE_CUSTOMER_URL_LINK_TYPE_FAIL,
    payload: error,
  };
};

// Customer Url Link Type Update
export const updateCustomerURLLinkType = (data) => {
  return {
    type: UPDATE_CUSTOMER_URL_LINK_TYPE,
    payload: data,
  };
};

export const updateCustomerURLLinkTypeSuccess = (data) => {
  return {
    type: UPDATE_CUSTOMER_URL_LINK_TYPE_SUCCESS,
    payload: data,
  };
};

export const updateCustomerURLLinkTypeFail = (error) => {
  return {
    type: UPDATE_CUSTOMER_URL_LINK_TYPE_FAIL,
    payload: error,
  };
};

// Customer Url Link Type Delete
export const deleteCustomerURLLinkType = (id) => {
  return {
    type: DELETE_CUSTOMER_URL_LINK_TYPE,
    payload: id,
  };
};

export const deleteCustomerURLLinkTypeSuccess = (id) => {
  return {
    type: DELETE_CUSTOMER_URL_LINK_TYPE_SUCCESS,
    payload: id,
  };
};

export const deleteCustomerURLLinkTypeFail = (error) => {
  return {
    type: DELETE_CUSTOMER_URL_LINK_TYPE_FAIL,
    payload: error,
  };
};

// Customer Debit Balance List
export const getCustomersDebitBalanceListData = () => {
  return {
    type: GET_CUSTOMERS_DEBIT_BALANCE_LIST_DATA,
  };
};

export const getCustomersDebitBalanceListDataSuccess = (data) => {
  return {
    type: GET_CUSTOMERS_DEBIT_BALANCE_LIST_DATA_SUCCESS,
    payload: data,
  };
};

export const getCustomersDebitBalanceListDataFail = (error) => {
  return {
    type: GET_CUSTOMERS_DEBIT_BALANCE_LIST_DATA_FAIL,
    payload: error,
  };
};

// Customer Overdue Balance List
export const getCustomersOverdueBalanceListData = () => {
  return {
    type: GET_CUSTOMERS_OVERDUE_BALANCE_LIST_DATA,
  };
};

export const getCustomersOverdueBalanceListDataSuccess = (data) => {
  return {
    type: GET_CUSTOMERS_OVERDUE_BALANCE_LIST_DATA_SUCCESS,
    payload: data,
  };
};

export const getCustomersOverdueBalanceListDataFail = (error) => {
  return {
    type: GET_CUSTOMERS_OVERDUE_BALANCE_LIST_DATA_FAIL,
    payload: error,
  };
};

// Customer Balance List All
export const getCustomersBalanceListAllData = () => {
  return {
    type: GET_CUSTOMERS_BALANCE_LIST_ALL_DATA,
  };
};

export const getCustomersBalanceListAllDataSuccess = (data) => {
  return {
    type: GET_CUSTOMERS_BALANCE_LIST_ALL_DATA_SUCCESS,
    payload: data,
  };
};

export const getCustomersBalanceListAllDataFail = (error) => {
  return {
    type: GET_CUSTOMERS_BALANCE_LIST_ALL_DATA_FAIL,
    payload: error,
  };
};

// Clear Customer Transactions List
export const clearCustomerTransactionsList = (data) => {
  return {
    type: CLEAR_CUSTOMER_TRANSACTIONS_LIST,
    payload: data,
  };
};

export const clearCustomerTransactionsListSuccess = (data) => {
  return {
    type: CLEAR_CUSTOMER_TRANSACTIONS_LIST_SUCCESS,
    payload: data,
  };
};

export const clearCustomerTransactionsListFail = (error) => {
  return {
    type: CLEAR_CUSTOMER_TRANSACTIONS_LIST_FAIL,
    payload: error,
  };
};

// Single Customer External IDs Details
export const getSingleCustomerExternalIDsDetails = (id) => {
  return {
    type: GET_SINGLE_CUSTOMER_EXTERNAL_IDS_DETAILS,
    payload: id,
  };
};

export const getSingleCustomerExternalIDsDetailsSuccess = (data) => {
  return {
    type: GET_SINGLE_CUSTOMER_EXTERNAL_IDS_DETAILS_SUCCESS,
    payload: data,
  };
};

export const getSingleCustomerExternalIDsDetailsFail = (error) => {
  return {
    type: GET_SINGLE_CUSTOMER_EXTERNAL_IDS_DETAILS_FAIL,
    payload: error,
  };
};

// Single Customer External IDs Create
export const createSingleCustomerExternalIDs = (data) => {
  return {
    type: CREATE_SINGLE_CUSTOMER_EXTERNAL_IDS,
    payload: data,
  };
};

export const createSingleCustomerExternalIDsSuccess = (data) => {
  return {
    type: CREATE_SINGLE_CUSTOMER_EXTERNAL_IDS_SUCCESS,
    payload: data,
  };
};

export const createSingleCustomerExternalIDsFail = (error) => {
  return {
    type: CREATE_SINGLE_CUSTOMER_EXTERNAL_IDS_FAIL,
    payload: error,
  };
};

// Single Customer External IDs Update
export const updateSingleCustomerExternalIDs = (data) => {
  return {
    type: UPDATE_SINGLE_CUSTOMER_EXTERNAL_IDS,
    payload: data,
  };
};

export const updateSingleCustomerExternalIDsSuccess = (data) => {
  return {
    type: UPDATE_SINGLE_CUSTOMER_EXTERNAL_IDS_SUCCESS,
    payload: data,
  };
};

export const updateSingleCustomerExternalIDsFail = (error) => {
  return {
    type: UPDATE_SINGLE_CUSTOMER_EXTERNAL_IDS_FAIL,
    payload: error,
  };
};

// Single Customer External IDs Delete
export const deleteSingleCustomerExternalIDs = (id) => {
  return {
    type: DELETE_SINGLE_CUSTOMER_EXTERNAL_IDS,
    payload: id,
  };
};

export const deleteSingleCustomerExternalIDsSuccess = (id) => {
  return {
    type: DELETE_SINGLE_CUSTOMER_EXTERNAL_IDS_SUCCESS,
    payload: id,
  };
};

export const deleteSingleCustomerExternalIDsFail = (error) => {
  return {
    type: DELETE_SINGLE_CUSTOMER_EXTERNAL_IDS_FAIL,
    payload: error,
  };
};

// Single Customer External IDs External Identification Provider List
export const getSingleCustomerExternalIDsExternalIdentificationProviderListData =
  () => {
    return {
      type: GET_SINGLE_CUSTOMER_EXTERNAL_IDS_EXTERNAL_IDENTIFICATION_PROVIDER_LIST_DATA,
    };
  };

export const getSingleCustomerExternalIDsExternalIdentificationProviderListDataSuccess =
  (data) => {
    return {
      type: GET_SINGLE_CUSTOMER_EXTERNAL_IDS_EXTERNAL_IDENTIFICATION_PROVIDER_LIST_DATA_SUCCESS,
      payload: data,
    };
  };

export const getSingleCustomerExternalIDsExternalIdentificationProviderListDataFail =
  (error) => {
    return {
      type: GET_SINGLE_CUSTOMER_EXTERNAL_IDS_EXTERNAL_IDENTIFICATION_PROVIDER_LIST_DATA_FAIL,
      payload: error,
    };
  };

// Single Customer External IDs External Identification Provider Details
export const getSingleCustomerExternalIDsExternalIdentificationProviderDetails =
  (id) => {
    return {
      type: GET_SINGLE_CUSTOMER_EXTERNAL_IDS_EXTERNAL_IDENTIFICATION_PROVIDER_DETAILS,
      payload: id,
    };
  };

export const getSingleCustomerExternalIDsExternalIdentificationProviderDetailsSuccess =
  (data) => {
    return {
      type: GET_SINGLE_CUSTOMER_EXTERNAL_IDS_EXTERNAL_IDENTIFICATION_PROVIDER_DETAILS_SUCCESS,
      payload: data,
    };
  };

export const getSingleCustomerExternalIDsExternalIdentificationProviderDetailsFail =
  (error) => {
    return {
      type: GET_SINGLE_CUSTOMER_EXTERNAL_IDS_EXTERNAL_IDENTIFICATION_PROVIDER_DETAILS_FAIL,
      payload: error,
    };
  };

// Single Customer External IDs External Identification Provider Create
export const createSingleCustomerExternalIDsExternalIdentificationProvider = (
  data
) => {
  return {
    type: CREATE_SINGLE_CUSTOMER_EXTERNAL_IDS_EXTERNAL_IDENTIFICATION_PROVIDER,
    payload: data,
  };
};

export const createSingleCustomerExternalIDsExternalIdentificationProviderSuccess =
  (data) => {
    return {
      type: CREATE_SINGLE_CUSTOMER_EXTERNAL_IDS_EXTERNAL_IDENTIFICATION_PROVIDER_SUCCESS,
      payload: data,
    };
  };

export const createSingleCustomerExternalIDsExternalIdentificationProviderFail =
  (error) => {
    return {
      type: CREATE_SINGLE_CUSTOMER_EXTERNAL_IDS_EXTERNAL_IDENTIFICATION_PROVIDER_FAIL,
      payload: error,
    };
  };

// Single Customer External IDs External Identification Provider Update
export const updateSingleCustomerExternalIDsExternalIdentificationProvider = (
  data
) => {
  return {
    type: UPDATE_SINGLE_CUSTOMER_EXTERNAL_IDS_EXTERNAL_IDENTIFICATION_PROVIDER,
    payload: data,
  };
};

export const updateSingleCustomerExternalIDsExternalIdentificationProviderSuccess =
  (data) => {
    return {
      type: UPDATE_SINGLE_CUSTOMER_EXTERNAL_IDS_EXTERNAL_IDENTIFICATION_PROVIDER_SUCCESS,
      payload: data,
    };
  };

export const updateSingleCustomerExternalIDsExternalIdentificationProviderFail =
  (error) => {
    return {
      type: UPDATE_SINGLE_CUSTOMER_EXTERNAL_IDS_EXTERNAL_IDENTIFICATION_PROVIDER_FAIL,
      payload: error,
    };
  };

// Single Customer External IDs External Identification Provider Delete
export const deleteSingleCustomerExternalIDsExternalIdentificationProvider = (
  id
) => {
  return {
    type: DELETE_SINGLE_CUSTOMER_EXTERNAL_IDS_EXTERNAL_IDENTIFICATION_PROVIDER,
    payload: id,
  };
};

export const deleteSingleCustomerExternalIDsExternalIdentificationProviderSuccess =
  (id) => {
    return {
      type: DELETE_SINGLE_CUSTOMER_EXTERNAL_IDS_EXTERNAL_IDENTIFICATION_PROVIDER_SUCCESS,
      payload: id,
    };
  };

export const deleteSingleCustomerExternalIDsExternalIdentificationProviderFail =
  (error) => {
    return {
      type: DELETE_SINGLE_CUSTOMER_EXTERNAL_IDS_EXTERNAL_IDENTIFICATION_PROVIDER_FAIL,
      payload: error,
    };
  };

// Customer Status List
export const getCustomerStatusListData = () => {
  return {
    type: GET_CUSTOMER_STATUS_LIST_DATA,
  };
};

export const getCustomerStatusListDataSuccess = (data) => {
  return {
    type: GET_CUSTOMER_STATUS_LIST_DATA_SUCCESS,
    payload: data,
  };
};

export const getCustomerStatusListDataFail = (error) => {
  return {
    type: GET_CUSTOMER_STATUS_LIST_DATA_FAIL,
    payload: error,
  };
};

// Customer Status Details
export const getCustomerStatusDetails = (id) => {
  return {
    type: GET_CUSTOMER_STATUS_DETAILS,
    payload: id,
  };
};

export const getCustomerStatusDetailsSuccess = (data) => {
  return {
    type: GET_CUSTOMER_STATUS_DETAILS_SUCCESS,
    payload: data,
  };
};

export const getCustomerStatusDetailsFail = (error) => {
  return {
    type: GET_CUSTOMER_STATUS_DETAILS_FAIL,
    payload: error,
  };
};

// Customer Status Create
export const createCustomerStatus = (data) => {
  return {
    type: CREATE_CUSTOMER_STATUS,
    payload: data,
  };
};

export const createCustomerStatusSuccess = (data) => {
  return {
    type: CREATE_CUSTOMER_STATUS_SUCCESS,
    payload: data,
  };
};

export const createCustomerStatusFail = (error) => {
  return {
    type: CREATE_CUSTOMER_STATUS_FAIL,
    payload: error,
  };
};

// Customer Status Update
export const updateCustomerStatus = (data) => {
  return {
    type: UPDATE_CUSTOMER_STATUS,
    payload: data,
  };
};

export const updateCustomerStatusSuccess = (data) => {
  return {
    type: UPDATE_CUSTOMER_STATUS_SUCCESS,
    payload: data,
  };
};

export const updateCustomerStatusFail = (error) => {
  return {
    type: UPDATE_CUSTOMER_STATUS_FAIL,
    payload: error,
  };
};

// Customer Status Delete
export const deleteCustomerStatus = (id) => {
  return {
    type: DELETE_CUSTOMER_STATUS,
    payload: id,
  };
};

export const deleteCustomerStatusSuccess = (id) => {
  return {
    type: DELETE_CUSTOMER_STATUS_SUCCESS,
    payload: id,
  };
};

export const deleteCustomerStatusFail = (error) => {
  return {
    type: DELETE_CUSTOMER_STATUS_FAIL,
    payload: error,
  };
};

// Customer Type List
export const getCustomerTypeListData = () => {
  return {
    type: GET_CUSTOMER_TYPE_LIST_DATA,
  };
};

export const getCustomerTypeListDataSuccess = (data) => {
  return {
    type: GET_CUSTOMER_TYPE_LIST_DATA_SUCCESS,
    payload: data,
  };
};

export const getCustomerTypeListDataFail = (error) => {
  return {
    type: GET_CUSTOMER_TYPE_LIST_DATA_FAIL,
    payload: error,
  };
};

// Customer Type Details
export const getCustomerTypeDetails = (id) => {
  return {
    type: GET_CUSTOMER_TYPE_DETAILS,
    payload: id,
  };
};

export const getCustomerTypeDetailsSuccess = (data) => {
  return {
    type: GET_CUSTOMER_TYPE_DETAILS_SUCCESS,
    payload: data,
  };
};

export const getCustomerTypeDetailsFail = (error) => {
  return {
    type: GET_CUSTOMER_TYPE_DETAILS_FAIL,
    payload: error,
  };
};

// Customer Type Create
export const createCustomerType = (data) => {
  return {
    type: CREATE_CUSTOMER_TYPE,
    payload: data,
  };
};

export const createCustomerTypeSuccess = (data) => {
  return {
    type: CREATE_CUSTOMER_TYPE_SUCCESS,
    payload: data,
  };
};

export const createCustomerTypeFail = (error) => {
  return {
    type: CREATE_CUSTOMER_TYPE_FAIL,
    payload: error,
  };
};

// Customer Type Update
export const updateCustomerType = (data) => {
  return {
    type: UPDATE_CUSTOMER_TYPE,
    payload: data,
  };
};

export const updateCustomerTypeSuccess = (data) => {
  return {
    type: UPDATE_CUSTOMER_TYPE_SUCCESS,
    payload: data,
  };
};

export const updateCustomerTypeFail = (error) => {
  return {
    type: UPDATE_CUSTOMER_TYPE_FAIL,
    payload: error,
  };
};

// Customer Type Delete
export const deleteCustomerType = (id) => {
  return {
    type: DELETE_CUSTOMER_TYPE,
    payload: id,
  };
};

export const deleteCustomerTypeSuccess = (id) => {
  return {
    type: DELETE_CUSTOMER_TYPE_SUCCESS,
    payload: id,
  };
};

export const deleteCustomerTypeFail = (error) => {
  return {
    type: DELETE_CUSTOMER_TYPE_FAIL,
    payload: error,
  };
};

// Export Contacts
export const exportContacts = (data) => {
  return {
    type: EXPORT_CONTACTS,
    payload: data,
  };
};

export const exportContactsSuccess = (data) => {
  return {
    type: EXPORT_CONTACTS_SUCCESS,
    payload: data,
  };
};

export const exportContactsFail = (error) => {
  return {
    type: EXPORT_CONTACTS_FAIL,
    payload: error,
  };
};

// Search Customer
export const searchCustomer = (data) => {
  return {
    type: SEARCH_CUSTOMER,
    payload: data,
  };
};
export const searchCustomerSuccess = (data) => {
  return {
    type: SEARCH_CUSTOMER_SUCCESS,
    payload: data,
  };
};
export const searchCustomerFail = (error) => {
  return {
    type: SEARCH_CUSTOMER_FAIL,
    payload: error,
  };
};

// Get Customer Balance Historical Available Dates
export const getCustomerBalanceHistoricalAvailableDates = () => {
  return {
    type: GET_CUSTOMER_BALANCE_HISTORICAL_AVAILABLE_DATES,
  };
};
export const getCustomerBalanceHistoricalAvailableDatesSuccess = (data) => {
  return {
    type: GET_CUSTOMER_BALANCE_HISTORICAL_AVAILABLE_DATES_SUCCESS,
    payload: data,
  };
};
export const getCustomerBalanceHistoricalAvailableDatesFail = (error) => {
  return {
    type: GET_CUSTOMER_BALANCE_HISTORICAL_AVAILABLE_DATES_FAIL,
    payload: error,
  };
};

// Get Customer Balance Historical Specific Date
export const getCustomerBalanceHistoricalSpecificDate = (date) => {
  return {
    type: GET_CUSTOMER_BALANCE_HISTORICAL_SPECIFIC_DATE,
    payload: date,
  };
};
export const getCustomerBalanceHistoricalSpecificDateSuccess = (data) => {
  return {
    type: GET_CUSTOMER_BALANCE_HISTORICAL_SPECIFIC_DATE_SUCCESS,
    payload: data,
  };
};
export const getCustomerBalanceHistoricalSpecificDateFail = (error) => {
  return {
    type: GET_CUSTOMER_BALANCE_HISTORICAL_SPECIFIC_DATE_FAIL,
    payload: error,
  };
};

// Get Customer Balance Historical By Customer — pass { id: Customer_Id }
export const getCustomerBalanceHistoricalByCustomer = (id) => {
  return {
    type: GET_CUSTOMER_BALANCE_HISTORICAL_BY_CUSTOMER,
    payload: id,
  };
};
export const getCustomerBalanceHistoricalByCustomerSuccess = (data) => {
  return {
    type: GET_CUSTOMER_BALANCE_HISTORICAL_BY_CUSTOMER_SUCCESS,
    payload: data,
  };
};
export const getCustomerBalanceHistoricalByCustomerFail = (error) => {
  return {
    type: GET_CUSTOMER_BALANCE_HISTORICAL_BY_CUSTOMER_FAIL,
    payload: error,
  };
};
